import React from 'react';
import axios from 'axios';
import Dialog from 'Components/Core/Dialog';
import Form from 'Components/Core/Form/Form';
import FormElement from 'Components/Core/Form/FormElement';
import FormSelect from 'Components/Core/Form/FormSelect';
import './RezeptEdit.css';

export default function RezeptEdit(props) {

	const x = props.x;
	const wafId = props.id;

	function onDialogClosed() {
		if (typeof props.onCancel !== 'undefined') props.onCancel();
	}

	function cancel() {
		x.wad[props.id].hide();
	}

	function afterSend(result) {
		if (result.returncode === 1) {
			x.wad[props.id].hide();
			if (typeof props.onSaved !== 'undefined') props.onSaved(result);
		}
	}

	const editButtons =
		<button type="button" className="btn" onClick={cancel}>Abbrechen</button>

	return (
		<Dialog id={props.id} x={x} title={props.title} classes="dialog-rezept-edit" closeIcon="1" handleClose={onDialogClosed}>
			<Form x={x}
				wafId={wafId}
				module="Rezepte"
				sendTask="RezeptSave"
				focusElement="name"
				cancelButton={false}
				buttons={editButtons}
				onAfterSend={afterSend}
			>
				<div className="rezept-edit-row">
					<FormSelect
						id='select-rezept-kategorie'
						fieldId='kategorieid'
						wafId={wafId}
						name="kategorieid"
						x={x}
						classes="form-select-kategorie rezept-edit-kategorie"
						dialogClasses="dialog-select-rezept-kategorie"
						default=""
						defaultKey={0}
						title="Kategorie"
						mandatory={true}
						onSetData={() => {
							const getKategorien = async () => {
								const data = [];
								const url = '/Backend/webapp.php?module=Rezepte&task=KategorieList';
								const resultData = await axios.get(url);
								resultData.data.content.forEach((item) => {
									data.push({ 'id': item.kategorieid, 'name': item.name });
								});
								return data;
							};
							return getKategorien();
						}}
						resetIcon={false}
					/>
					<FormElement type="text"
						x={x}
						wafId={wafId}
						id="name"
						mandatory={true}
						title="Titel"
						fieldValue=""
						maxLength="255"
						classes="rezept-edit-name"
					/>
				</div>
				<div className="rezept-edit-description-wrap">
					<FormElement type="textarea"
						x={x}
						wafId={wafId}
						id="description"
						mandatory={false}
						title="Beschreibung"
						fieldValue=""
						maxLength="200000"
					/>
				</div>
			</Form>
		</Dialog>
	)

};
